"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = range;
function range(ct) {
  return new Array(ct).fill(0).map((_, i) => i);
}